/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import { Link } from "react-router-dom";
// BASE components
import BASESvgIcon from '../../../../@BASE/core/BASESvgIcon';
// Material UI components
import Card from '@mui/material/Card';
import CardHeader from "@mui/material/CardHeader";
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Divider from "@mui/material/Divider";
import authRoles from "../../../auth/authRoles";

function OrganizationsListItem(props) {
  const { organization, user } = props;

  return (
    <Card className="flex flex-col shadow relative">
      <CardHeader
        avatar={
          <Avatar alt={organization.name} src={`${window.location.origin.toString()}/assets/images/logos/${organization.logo}`} variant="square" />
        }
        className="p-24 pb-0"
        action={
          (authRoles.admin.includes(user.role)) && (
            <Button
              variant="text"
              aria-label="Edit"
              startIcon={
                <BASESvgIcon size={16}>
                  heroicons-outline:pencil-alt
                </BASESvgIcon>
              }
              className="justify-end mr-8"
              to={`${organization.id}/edit`}
              component={Link}
            >
              Edit
            </Button>
          )
        }
      />
      <CardContent className="flex flex-col flex-auto p-24">
        <Typography className="text-15 font-medium">{organization.name}</Typography>
        <Divider className="my-16 border-1" />
        <div className="flex flex-col space-y-5">
          {organization.address && (
            <div className="flex items-start">
              <BASESvgIcon color="disabled" size={16}>heroicons-solid:location-marker</BASESvgIcon>
              <div className="ml-10 leading-6">
                <Typography className="text-12 font-medium" color="text.secondary">{organization.address.street}</Typography>
                <Typography className="text-12 font-medium" color="text.secondary">{organization.address.city}, {organization.address.state} {organization.address.zip}</Typography>
              </div>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}

export default OrganizationsListItem;
